import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { PAGE_SIZE } from '../../common/constants';
import { getPrdReturnReasonComment } from '../amazon.services';
import '../amazon.scss';
import { formatDate, isEmptyArray } from '../../common/util.services';
import { Link } from 'react-router-dom';

const AmazonReturnReasonComment = (props: any) => {
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const [returnComment, setReturnComment] = useState(rows)
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);
  const columns: GridColDef[] = [
    { field: 'date', headerName: 'Date', width: 100, filterable: false, sortable: false, editable: false,
      valueFormatter: (value: any) => formatDate(value)
    },
    { field: 'orderId', headerName: 'Order Id', width: 165, filterable: false, sortable: false, editable: false,
      renderCell: (params) => { return (<Link to={'https://sellercentral.amazon.com/orders-v3/order/' + params.row.orderId} 
                                        target="_blank">{params.row.orderId}</Link>)}
    },
    { field: 'product', headerName: 'Product', width: 150, filterable: false, sortable: false, editable: false},
    { field: 'color', headerName: 'Color', width: 100, filterable: false, sortable: false, editable: false},
    { field: 'size', headerName: 'Size', width: 90, filterable: false, sortable: false, editable: false, },
    { field: 'unitCount', headerName: 'Pack', width: 55, filterable: false, sortable: false, editable: false,},
    { field: 'comment', headerName: 'Comment', width: 550, filterable: false, sortable: false, editable: false }
  ];

  useEffect(() => {
    if (isEmptyArray(rows)) {
      setLoading(true);
      getPrdReturnReasonComment(props.product, props.reason, page, pageSize, appContext,
        (response: any) => {
          setReturnComment(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }, [page, pageSize]);

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const getMainPanel = () => {
    return <>
      <IGridComponent title={''} rows={returnComment} columns={columns} loading={loading} maxHeight={450}
        paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
        getRowId={(row: any) => row.rowId} showAction={false}/>
    </>
  }

  return <TitlePanel title='' panelBody={getMainPanel()} />
}

export default AmazonReturnReasonComment;